import { ContextWrapper } from '@common/contexts/ContextWrapper';
import { ClientStore } from '@common/stores';

export const ClientStoreContextWrapper = new ContextWrapper<ClientStore>();
